export const SESSION_CLOSED_CODE = 40110
export const SESSION_MESSAGE = 'Sessions limit exceeded.'
export const LIMIT_CODE = 10
export const CANCELED_REQUEST = 'ERR_CANCELED'
export const SESSION_CLOSED_CODE_NEW = 1005
export const SESSION_IS_CLOSED = 1010
